import { render, staticRenderFns } from "./punchtheclock.vue?vue&type=template&id=2c8745c4&scoped=true&"
import script from "./punchtheclock.vue?vue&type=script&lang=js&"
export * from "./punchtheclock.vue?vue&type=script&lang=js&"
import style0 from "./punchtheclock.vue?vue&type=style&index=0&lang=css&"
import style1 from "./punchtheclock.vue?vue&type=style&index=1&id=2c8745c4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8745c4",
  null
  
)

export default component.exports